import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'feedbackManagement',
  initialState: {
    // Feedback Type
    feedbackTypeListLoading: false,
    feedbackTypeList: [],
    feedbackTypePagination: {},
    feedbackTypeDetailsLoading: false,
    feedbackTypeDetails: null,
    updateFeedbackType: false,

    // User Feedback
    userFeedbackListLoading: false,
    userFeedbackList: [],
    userFeedbackPagination: {},
    userFeedbackDetailsLoading: false,
    userFeedbackDetails: null,
    updateUserFeedback: false,

    modalOpen: false,
    ApiError: '',
  },
  reducers: {
    // ================= Feedback Type (full CRUD) =================
    getFeedbackTypeListApiData: (state) => {
      state.feedbackTypeListLoading = true
    },
    getFeedbackTypeListApiSuccess: (state, { payload }) => {
      state.feedbackTypeListLoading = false
      state.feedbackTypeList = payload?.payload?.data || []
      state.feedbackTypePagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getFeedbackTypeListApiFailed: (state, { payload }) => {
      state.feedbackTypeListLoading = false
      state.ApiError = payload?.message
    },

    getFeedbackTypeDetailsApiData: (state) => {
      state.feedbackTypeDetailsLoading = true
    },
    getFeedbackTypeDetailsApiSuccess: (state, { payload }) => {
      state.feedbackTypeDetailsLoading = false
      state.feedbackTypeDetails = payload?.payload?.data || null
    },
    getFeedbackTypeDetailsApiFailed: (state, { payload }) => {
      state.feedbackTypeDetailsLoading = false
      state.ApiError = payload?.message
    },

    addFeedbackTypeApiData: (state) => {
      state.feedbackTypeListLoading = true
      state.updateFeedbackType = false
      state.modalOpen = false
    },
    addFeedbackTypeApiSuccess: (state, { payload }) => {
      state.updateFeedbackType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.feedbackTypeListLoading = false
      if (payload?.payload?.data) {
        state.feedbackTypeList.unshift(payload.payload.data)
      }
    },
    addFeedbackTypeApiFailed: (state, { payload }) => {
      state.updateFeedbackType = false
      state.feedbackTypeListLoading = false
      state.ApiError = payload?.message
    },

    updateFeedbackTypeApiData: (state) => {
      state.feedbackTypeListLoading = true
      state.updateFeedbackType = false
    },
    updateFeedbackTypeApiSuccess: (state, { payload }) => {
      state.updateFeedbackType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      state.feedbackTypeListLoading = false
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.feedbackTypeList = state.feedbackTypeList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateFeedbackTypeApiFailed: (state, { payload }) => {
      state.updateFeedbackType = false
      state.feedbackTypeListLoading = false
      state.ApiError = payload?.message
    },

    deleteFeedbackTypeApiData: (state, { payload }) => {
      state.feedbackTypeList = state.feedbackTypeList.filter((item) => item.id !== payload?.id)
      state.updateFeedbackType = false
    },
    deleteFeedbackTypeApiSuccess: (state, { payload }) => {
      state.updateFeedbackType = true
      state.ApiError = payload?.payload
      state.modalOpen = true
    },
    deleteFeedbackTypeApiFailed: (state, { payload }) => {
      state.updateFeedbackType = false
      state.ApiError = payload?.message
    },

    toggleFeedbackTypeStatusApiData: (state) => {
      state.feedbackTypeListLoading = true
      state.updateFeedbackType = false
    },
    toggleFeedbackTypeStatusApiSuccess: (state, { payload }) => {
      state.feedbackTypeListLoading = false
      state.updateFeedbackType = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.feedbackTypeList = state.feedbackTypeList.map((item) =>
          item.id === updated.id ? { ...item, is_active: updated.is_active } : item,
        )
      }
    },
    toggleFeedbackTypeStatusApiFailed: (state, { payload }) => {
      state.feedbackTypeListLoading = false
      state.updateFeedbackType = false
      state.ApiError = payload?.message
    },

    // ================= User Feedback =================
    getUserFeedbackListApiData: (state) => {
      state.userFeedbackListLoading = true
    },
    getUserFeedbackListApiSuccess: (state, { payload }) => {
      state.userFeedbackListLoading = false
      state.userFeedbackList = payload?.payload?.data || []
      state.userFeedbackPagination = {
        rowCount: payload?.payload?.total,
        page: payload?.payload?.page,
        size: payload?.payload?.size,
        nextPage: payload?.payload?.next_page,
        previousPage: payload?.payload?.previous_page,
      }
    },
    getUserFeedbackListApiFailed: (state, { payload }) => {
      state.userFeedbackListLoading = false
      state.ApiError = payload?.message
    },

    getUserFeedbackDetailsApiData: (state) => {
      state.userFeedbackDetailsLoading = true
    },
    getUserFeedbackDetailsApiSuccess: (state, { payload }) => {
      state.userFeedbackDetailsLoading = false
      state.userFeedbackDetails = payload?.payload?.data || null
    },
    getUserFeedbackDetailsApiFailed: (state, { payload }) => {
      state.userFeedbackDetailsLoading = false
      state.ApiError = payload?.message
    },

    updateUserFeedbackStatusApiData: (state) => {
      state.userFeedbackListLoading = true
      state.updateUserFeedback = false
    },
    updateUserFeedbackStatusApiSuccess: (state, { payload }) => {
      state.userFeedbackListLoading = false
      state.updateUserFeedback = true
      state.modalOpen = true
      state.ApiError = payload?.payload
      if (payload?.payload?.data) {
        const updated = payload.payload.data
        state.userFeedbackList = state.userFeedbackList.map((item) =>
          item.id === updated.id ? updated : item,
        )
      }
    },
    updateUserFeedbackStatusApiFailed: (state, { payload }) => {
      state.userFeedbackListLoading = false
      state.updateUserFeedback = false
      state.ApiError = payload?.message
    },

    resetFeedbackError: (state) => {
      state.ApiError = ''
      state.modalOpen = false
    },
  },
})

export const {
  // Feedback Type
  getFeedbackTypeListApiData,
  getFeedbackTypeListApiSuccess,
  getFeedbackTypeListApiFailed,
  getFeedbackTypeDetailsApiData,
  getFeedbackTypeDetailsApiSuccess,
  getFeedbackTypeDetailsApiFailed,
  addFeedbackTypeApiData,
  addFeedbackTypeApiSuccess,
  addFeedbackTypeApiFailed,
  updateFeedbackTypeApiData,
  updateFeedbackTypeApiSuccess,
  updateFeedbackTypeApiFailed,
  deleteFeedbackTypeApiData,
  deleteFeedbackTypeApiSuccess,
  deleteFeedbackTypeApiFailed,
  toggleFeedbackTypeStatusApiData,
  toggleFeedbackTypeStatusApiSuccess,
  toggleFeedbackTypeStatusApiFailed,

  // User Feedback
  getUserFeedbackListApiData,
  getUserFeedbackListApiSuccess,
  getUserFeedbackListApiFailed,
  getUserFeedbackDetailsApiData,
  getUserFeedbackDetailsApiSuccess,
  getUserFeedbackDetailsApiFailed,
  updateUserFeedbackStatusApiData,
  updateUserFeedbackStatusApiSuccess,
  updateUserFeedbackStatusApiFailed,

  resetFeedbackError,
} = slice.actions

export default slice.reducer
